import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import { HealthDataType } from '../../../Enums/HealthDataType.enum';

export const baseHealthDataFilterSchemeDefault: ItemScheme[] = [
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.viewInterval',
	},
	{
		type: MagicField.RADIOLIST,
		key: 'view',
		children: [
			{
				value: 'day',
				title: 'component.chart.filter.day',
			},
			{
				value: 'week',
				title: 'component.chart.filter.week',
			},
			{
				value: 'month',
				title: 'component.chart.filter.month',
			},
			{
				value: 'year',
				title: 'component.chart.filter.year',
			},
			{
				value: 'custom',
				title: 'component.chart.filter.custom',
			},
		],
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'day',
				},
			],
		},
		children: [
			{
				type: MagicField.DATEPICKER,
				key: 'date',
				title: 'component.chart.filter.date',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.RADIOLIST,
				key: 'dataType',
				children: [
					{
						value: HealthDataType.DEFAULT,
						title: 'component.chart.filter.averageValues',
					},
					{
						value: HealthDataType.RAW,
						title: 'component.chart.filter.allValues',
					},
				],
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.CONDITION,
		value: 'view',
		settings: {
			rules: [
				{
					formControlKey: 'view',
					rule: 'equal',
					value: 'custom',
				},
			],
		},
		children: [
			{
				type: MagicField.TEXT,
				subType: 'filterLabel',
				title: 'component.chart.filter.period',
			},
			{
				type: MagicField.DATEPICKER,
				key: 'from',
				title: 'component.chart.filter.dateFrom',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.DATEPICKER,
				key: 'to',
				title: 'component.chart.filter.dateTo',
				settings: {
					required: true,
				},
			},
		],
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.chartsAndTables',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleSteps',
		title: 'component.chart.filter.steps',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleDistanceWalkingRunning',
		title: 'component.chart.filter.distanceWalkingRunning',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleSleep',
		title: 'component.chart.filter.sleep',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleActiveEnergy',
		title: 'component.chart.filter.activeEnergy',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleWorkout',
		title: 'component.chart.filter.workout',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleOxygenSaturation',
		title: 'component.chart.filter.oxygenSaturation',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleWeight',
		title: 'component.chart.filter.weight',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleStressLevel',
		title: 'component.chart.filter.stressLevel',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleBreathingRate',
		title: 'component.chart.filter.breathingRate',
	},
	{
		type: MagicField.CHECKBOX,
		key: 'toggleBloodPressure',
		title: 'component.chart.filter.bloodPressureAndHearthBeat',
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'component.chart.filter.dataSource',
	},
	{
		type: MagicField.CONTAINER,
		key: 'source',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'appleHealth',
				title: 'component.chart.filter.appleHealth',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'googleFit',
				title: 'component.chart.filter.googleFit',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'bioScan',
				title: 'component.chart.filter.bioScan',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'ingestion',
				title: 'component.chart.filter.ingestion',
			},
		],
	},
];
